// extracted by mini-css-extract-plugin
module.exports = {"prev":"pagination_prev__3VJce","current":"pagination_current__3Gvky","next":"pagination_next__2hDZU"};